import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  useStore,
} from 'react-admin'
import { Container, FormControl, InputLabel, Skeleton } from '@mui/material'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { CardCommon } from 'src/components/uiElements'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { entityServices } from 'src/services/auth/entity/entity.service'
import { useQuery } from 'react-query'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

const SelectArrayInputFn = ({
  queryName,
  label,
  optionsText = ['long_name'],
  optionValue,
  source,
  queryFn,
  ...props
}) => {
  const options = useQuery(queryName, () => queryFn())
  return options.isLoading ? (
    <Skeleton variant='rectangular' width={'270px'} height={'40px'} />
  ) : (
    <FormControl fullWidth className='select-array-input'>
      {label && <InputLabel>{label}</InputLabel>}
      <SelectInput
        source={source}
        options={options.data|| []}
        optionsText={optionsText}
        optionValue={optionValue}
        showSearch
        style={{width:325}}
        {...props}
      />
    </FormControl>
  )
}

export function PermissionList(props) {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return permissions?.options?.revision ||
      permissions?.hasShow ||
      permissions?.hasEdit ||
      permissions?.options?.delete
  }

  const permissionFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
    <TextInput label={translate('ra.field.action')} source='action' defaultValue='' />,
    <TextInput label={translate('ra.field.description')} source='description' defaultValue='' />,
    <SelectArrayInputFn 
      label={translate('ra.field.entity')} 
      source='entity_id' 
      defaultValue=''
      queryName='entity-all'
      optionsText = {['name']}
      optionValue = {['id']}
      queryFn={entityServices.getByAll}
    />,
    <TextInput label={translate('ra.field.module')} source='module_id' defaultValue='' />,
    <TextInput label={translate('ra.field.start_icon')} source='start_icon' defaultValue='' />,
    <TextInput label={translate('ra.field.menu')} source='menu' defaultValue='' />,
  ]

  return (
    <>
      <Container className='content'>
        <CardCommon title={translate('ra.entity.permission')}>
          <List {...props} component='div' filters={permissionFilters} actions={<ListViewTopToolbar hasCreate={permissions?.hasCreate} />}>
            <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
              <TextField label={translate('ra.field.id')} source='id' />
              <TextField label={translate('ra.field.action')} source='action' />
              <TextField label={translate('ra.field.description')} source='description' />
              <TextField label={translate('ra.field.entity')} source='entity_relation.name' />
              <TextField label={translate('ra.field.module')} source='module.long_name' />
              {hasPermissions() && (
                <ListViewActionsButtons label={translate('ra.field.action')} fieldsName={['description']} genderElement='masculine' />
              )}
            </Datagrid>
          </List>
        </CardCommon>
      </Container>
    </>
  )
}
